import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import {CourseToolsMixin} from '@/courses/mixins/course-tools.mixin';
import Moment from 'moment';
import { EdSectionOptions } from '@/content/models/ed-section-options.model';

@Component({
  name: 'ed-subject-day-content'
})
export default class EdSubjectDayContentComponent extends Mixins(CourseToolsMixin) {

  @Prop() readonly params: any;

  public sectionOptions: any = new EdSectionOptions(false);;
  public contentType: string = 'DAY_CONTENT';
  public saving: boolean = false;
  public loading: boolean = true;
  public sections: any = [];
  public objectsTagged: any = [];
  public objectOptions = { 
    draggable: false,
    selectable: false,
    editable: false
  };

  get classId() {
    return this.params.classId ? this.params.classId : 0;
  }

  get dateTitle() {
    let lan = this.$i18n.locale;
    let format = lan === 'es' ? 'dddd, D MMMM' : 'dddd, Do MMM';
    let date = Moment(this.params.date).locale(lan).format(format).toString()
    return date.charAt(0).toUpperCase() + date.slice(1)
  }

  get date () {
    return Moment(this.params.date).format('YYYY-MM-DD').toString();
  }

  get hasLesson() {
    return this.sections.id;
  }

  get hasContent() {
    return this.hasLesson || this.objectsTagged?.length > 0;
  }

  /* Methods */
  closeModal() {
    this.$EdModal.closeModal();
  }

  async getContent() {
    try {
      if(!this.params.lesson.createAsNew) {
        this.sections = await this.$Courses.Services.obtainSectionInfo(this.params.courseId, this.params.lesson?.id, this.classId);
        this.sections.sections = this.removeTaggedInSections(this.sections.sections);
      } else {
        /* Fake lesson content */
        this.sections = {
          ...this.params.lesson,
          fixedSection: 'LESSON',
          label: `${this.$t('courses.subjectBuilder.lesson')} ${this.params.lesson.fixedSequence}`,
          name: `${this.$t('courses.subjectBuilder.lesson')} ${this.params.lesson.fixedSequence}`,
          type: 'SECTION',
          sections: []
        }
      }
      /*  Add tagged objects to sections */
      this.objectsTagged = this.params.objectsTagged
        .filter(el => el.schoolDate === this.params.date && el.showObject)
        .map(el => { return {
          ...el,
          sections: el.sections ? el.sections : []
        }});
      this.loading = false;
    } catch {
      this.loading = false;
    }
  }

  removeTaggedInSections(sections) {
    let sectionIds = [];
    let sectionsCopy = [...sections];
    sectionsCopy.forEach(sec => {
      if(this.params.objectsTagged.find(tag => tag.id == sec.id)) {
        sectionIds.push(sec.id);
      } else {
        if(sec.sections.length > 0) {
          sec.sections = this.removeTaggedInSections(sec.sections); 
        }
      }
    });
    sections = sections.filter(sec => !sectionIds.find(id => id === sec.id));
    return sections;
  }

  getTooltipTaggedObj(section) {
    return !section.movedByBuilder ? this.$t('courses.subjectBuilder.rulesContainer.tagObjectInfo', 
    { tag: this.$t(`common.tags.${section.labelSections.toLowerCase()}`),
      weekday: this.$t(`common.weekdays.${Moment(section.schoolDate).format('dddd').toLowerCase()}`) }) : '';
  }

  mounted() {
    this.getContent();
  }
}